import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import {
  MaintenanceForwardingData,
  MaintenanceForwardingDirectiveEntryMap,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwarding.type'
import {
  MaintenanceForwardingEstablishmentChoiceEntryKlass,
  MaintenanceForwardingEstablishmentChoiceEntryMap,
} from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/establishmentChoiceEntries/establishmentChoiceEntry.type'
import { MaintenanceWorkflowData } from '@/features/maintenanceWorkflow/types/maintenanceWorkflows.type'
import { createContext, useContext } from 'react'

export const ForwardingTabContext = createContext<{
  workflow: MaintenanceWorkflowData | undefined
  forwarding:
    | MaintenanceForwardingData<
        MaintenanceForwardingDirectiveEntryMap[MaintenanceForwardingsDirectiveEntryKlass],
        MaintenanceForwardingEstablishmentChoiceEntryMap[MaintenanceForwardingEstablishmentChoiceEntryKlass]
      >
    | undefined
  forwardingUpdatedAt: number
  directiveEntryKlass: MaintenanceForwardingsDirectiveEntryKlass | undefined
  noActions?: boolean;
}>({
  workflow: undefined,
  forwarding: undefined,
  forwardingUpdatedAt: 0,
  directiveEntryKlass: undefined,
  noActions: false,
})

export const useForwardingTabContext = <
  DirectiveEntry extends MaintenanceForwardingsDirectiveEntryKlass,
  EstablishmentChoiceEntry extends MaintenanceForwardingEstablishmentChoiceEntryKlass = never,
>() =>
  useContext(ForwardingTabContext) as {
    workflow: MaintenanceWorkflowData | undefined
    forwarding: MaintenanceForwardingData<
      MaintenanceForwardingDirectiveEntryMap[DirectiveEntry],
      MaintenanceForwardingEstablishmentChoiceEntryMap[EstablishmentChoiceEntry]
    >
    forwardingUpdatedAt: number
    directiveEntryKlass: DirectiveEntry
    noActions?: boolean;
  }
